// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"table-state_noDataContainer__3Bans","error":"table-state_error__17byE","noDataContainer__modal":"table-state_noDataContainer__modal__2nI7T"};